import React from 'react';
import { useSelector } from 'react-redux';
import { activePlansHasFreeTrial } from 'helpers/ContentHelper';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Style from './UpgradeButton.module.scss';

const UpgradeButton = ({ isFreemium, isPersonality, onClick, isResumeButton, theme }) => {
  const { upsellPromoNavCTA, upsellPromoNavFreemiumCTA, upsellResumeButton } = window.Language;
  const { activePlans } = useSelector(state => state?.app);
  if (!activePlans) return null;
  const isFreeTrialPlanAvailable = activePlansHasFreeTrial(activePlans);
  let text = upsellPromoNavCTA;

  if (isFreemium || !isFreeTrialPlanAvailable) text = upsellPromoNavFreemiumCTA;
  if (isResumeButton) text = upsellResumeButton;

  return (
    <button
      data-testid="upsell-cta"
      className={classNames([
        Style.button,
        isPersonality ? Style.roundedButton : null,
        theme.upgradeButton,
      ])}
      onClick={() => {
        onClick({ text, isJoinNow: !isFreeTrialPlanAvailable });
      }}
      type="button"
    >
      {text}
    </button>
  );
};

UpgradeButton.defaultProps = {
  isFreemium: false,
  theme: {},
  onClick: () => {},
};

UpgradeButton.propTypes = {
  activePlans: PropTypes.shape({}),
  isFreemium: PropTypes.bool,
  isPersonality: PropTypes.bool,
  isResumeButton: PropTypes.bool,
  onClick: PropTypes.func,
  theme: PropTypes.shape({}),
};

export default UpgradeButton;
